export default {
  CREATE: {
    TITLE: `Créer une requête d'absence`,
    SUMMARY: `Prévenez votre gestionnaire d'une absence, d'un retard ou d'un départ hatif.`
  },
  EDIT: { TITLE: `Modifier la requête d'absence`, SUMMARY: `Modifiez une demande d'absence, de retard ou de départ hatif.` },
  VIEW: {
    TITLE: `Voir une requête d'absence`,
    SUMMARY: ``
  },
  EVENTID: {
    LABEL: `Quart de travail`,
    DESCRIPTION: `Sélectionnez le quart de travail pour lequel vous souhaitez créer une requête.`,
    EMPTY_PLACEHOLDER: `Vous n'avez aucun quart de travail pour lequel vous pouvez créer une requête`
  },
  REQUESTTYPEID: {
    LABEL: `Type de requête`,
    DESCRIPTION: ``
  },
  REASONID: {
    LABEL: `Raison`,
    DESCRIPTION: ``
  },
  COMMENT: {
    LABEL: `Commentaire`,
    PLACEHOLDER: `Écrivez un commentaire`,
    DESCRIPTION: ``
  },
  ARRIVALTIME: {
    LABEL: `Heure d'arrivée`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  DEPARTURETIME: {
    LABEL: `Heure de départ`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  COMMENT_REQUIRED: `Un commentaire est requis.`,
  SHIFT_REQUIRED: `Veuillez sélectionner un quart de travail.`,
  REQUEST_TYPE_ID_REQUIRED: `Veuillez sélectionner un type de requête.`,
  REASON_ID_REQUIRED: `Veuillez sélectionner une raison.`,
  ABSENCE: `Absence`,
  DELAY: `Retard`,
  EARLY_OUT: `Départ hâtif`,
  SUBMIT: `Soumettre`,
  QUIT_PAGE: `Les modifications apportées n'ont pas été sauvegardées. Souhaitez vous quitter quand même ?`,
  CANT_EDIT_INTRO: `La modification de cette requête n'est pas possible car :`,
  CANT_EDIT_EXPIRED: `le quart de travail ou le jour pour lequel elle a été créée a déjà commencé`,
  CANT_EDIT_INVALID_STATUS: `son statut est passé à `,
  CANT_EDIT_NO_PERMISSION: `vous n'avez pas les autorisations pour modifier une requête`,
  AND: `et`,
  INVALID_SHIFT_SELECTION: `Vous ne pouvez pas créer une requête sur le quart sélectionné à partir de votre horaire.`,
  NO_SHIFT_SELECTED: `Aucun quart sélectionné, veuillez sélectionner un quart.`,
  NOT_ALLOWED_TO_CREATE_ATTENDANCE: `Vous n'êtes pas autorisé à créer une requête d'absence. Veuillez en faire la demande à votre gestionnaire.`
}
